module.exports = __webpack_public_path__ + "383ff56a1cfd96d66bd7fea0a517aa57.png";